<template>
  <Modal v-model="showModal" :scrollable="true" :mask-closable="false" :width="width" @on-cancel="closeModal">
    <p slot="header">
      <Icon type="md-create" />
      <span class="header-label">车库终端配置</span>
    </p>
    <div style="position: relative;">
      <TableWrapper
        v-if="showModal"
        :columns="columns"
        :offset-height="offsetHeight"
        :mod-count="modCount"
        :url="action"
        :border="false"
        :show-add="addPermited"
        @on-add="showFormModalDialog"
      />
      <ParkingAgentDialog
        :id="entityId"
        :parking-id="id"
        :visible="modalForm"
        :width="350"
        @on-close="onAgentModalClose"
      />
      <ParkingAgentDevice
        :agent-id="entityId"
        :parking-id="id"
        :visible="modalAgentDevice"
        :width="60"
        @on-close="onAgentModalClose"
      />
    </div>
  </Modal>
</template>

<script>
import request from '@/utils/request'
import TableWrapper from '@/components/table-wrapper'
import ParkingAgentDialog from './dialog/parkingAgentDialog'
import ParkingAgentDevice from './parkingAgentDevice'
import { getLinkTextStyle } from '@/utils/util'
import { isAdmin, hasPermission } from '@/utils/app'
export default {
  name: 'ParkingAgentListDialog',
  components: {
    TableWrapper, ParkingAgentDialog, ParkingAgentDevice
  },
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    caption: {
      type: String,
      default: ''
    },
    width: {
      type: Number,
      default: 500
    },
    id: {
      type: Number,
      default: 0
    }
  },
  data() {
    return {
      loadingStatus: false,
      modal: true,
      modalForm: false,
      modalAgentDevice: false,
      submit: false,
      modCount: 0,
      entityId: 0
    }
  },
  computed: {
    addPermited() { return isAdmin() || hasPermission('PEM_GARAGE_AGENT_ADD') },
    deletePermitted() { return isAdmin() || hasPermission('PEM_GARAGE_AGENT_DELETE') },
    updatePermitted() { return isAdmin() || hasPermission('PEM_GARAGE_AGENT_UPDATE') },
    gateOpenPermitted() { return isAdmin() || hasPermission('PEM_GARAGE_GATE_OPEN') },
    rebootPermitted() { return isAdmin() || hasPermission('PEM_GARAGE_REBOOT') },
    deviceConfigPermitted() { return isAdmin() || hasPermission('PEM_GARAGE_AGENT_DEVICE_CONFIGURE') },
    deviceProvisionPermitted() { return isAdmin() || hasPermission('PEM_GARAGE_AGENT_DEVICE_PROVISION') },
    offsetHeight() {
      return 480
    },
    action() {
      return this.$config.apiContextPath + '/parking/' + this.id + '/agent'
    },
    showModal: {
      get() { return this.visible },
      set(value) { }
    },
    columns() {
      return [
        { title: '序号', type: 'index', width: 70, align: 'center' },
        { title: '终端标识', align: 'center', key: 'label', sortable: true, ellipsis: true, tooltip: true },
        { title: '终端地址', align: 'center', key: 'address', sortable: true, ellipsis: true, tooltip: true },
        { title: '射频', align: 'center', key: 'hasRadio', sortable: true, ellipsis: true, tooltip: true,
          render: (h, params) => {
            return h('span', {}, params.row.hasRadio === 1 ? '有' : '无')
          }
        },
        { title: '备注', align: 'center', key: 'remarks', sortable: true, ellipsis: true, tooltip: true,
          render: (h, params) => {
            return h('span', {}, params.row.remarks || '---')
          }
        },
        { title: '状态', align: 'center', key: 'status', sortable: true, width: 80, ellipsis: true, tooltip: true,
          render: (h, params) => {
            return h('span', {
              style: { color: params.row.status === 1 ? 'green' : 'red' }
            }, params.row.status === 1 ? '启用' : '停用')
          }
        },
        { title: '操作', align: 'center', width: 260,
          render: (h, params) => {
            const _this = this
            return h('div', [
              h('a', {
                style: getLinkTextStyle(_this.rebootPermitted),
                on: {
                  click: () => {
                    if (params.row.id && _this.rebootPermitted) {
                      this.showRebootModalDialog(params.row.label, params.row.address)
                    }
                  }
                }
              }, [
                h('i', { class: { 'fas': true, 'fa-wrench': true, 'cell-icon-link': true }}),
                h('span', {
                  domProps: {
                    title: '重启终端'
                  }
                }, '重启')
              ]),
              h('a', {
                style: getLinkTextStyle(_this.gateOpenPermitted),
                on: {
                  click: () => {
                    if (params.row.id && _this.gateOpenPermitted) {
                      this.showOpenDoorModalDialog(params.row.label, params.row.address, params.row.id)
                    }
                  }
                }
              }, [
                h('i', { class: { 'fas': true, 'fa-dungeon': true, 'cell-icon-link': true }}),
                h('span', { domProps: { title: _this.updatePermitted ? '远程开闸' : '您没有权限远程开闸' }}, '开闸')
              ]),

              h('Dropdown', {
                props: { trigger: 'hover', placement: 'bottom' },
                on: {
                  'on-click': (name) => {
                    if (params.row.id) {
                      this.onDeviceDropdownItemClick(name, params.row)
                    }
                  }
                }
              }, [
                h('DropdownItem', { style: { color: '#126D91' }}, [
                  h('i', { class: { 'fas': true, 'fa-cogs': true, 'cell-icon-link': true }}),
                  '设备',
                  h('Icon', { props: { type: 'ios-arrow-down' }})
                ]),
                h('DropdownMenu', { slot: 'list' }, [
                  h('DropdownItem', {
                    props: { name: 'action_config_device', disabled: !_this.deviceConfigPermitted }
                  }, [
                    h('i', { class: { 'fas': true, 'fa-cog': true, 'cell-icon-link': true }}),
                    h('span', {
                      domProps: {
                        title: _this.deviceConfigPermitted ? '配置设备' : '您没有权限配置设备'
                      }
                    }, '配置设备')
                  ]),
                  h('DropdownItem', {
                    props: { name: 'action_provision_device', disabled: !_this.deviceProvisionPermitted }
                  }, [
                    h('i', { class: { 'fas': true, 'fa-bolt': true, 'cell-icon-link': true }}),
                    h('span', { domProps: {
                      title: _this.deviceProvisionPermitted ? '下发设备' : '您没有权限下发设备'
                    }}, '下发设备')
                  ])
                ])
              ]),

              // h('a', {
              //   style: getLinkTextStyle(_this.deviceConfigPermitted),
              //   on: {
              //     click: () => {
              //       if (params.row.id && _this.deviceConfigPermitted) {
              //         this.showAgentDeviceModalDialog(params.row.id)
              //       }
              //     }
              //   }
              // }, [
              //   h('i', { class: { 'fas': true, 'fa-cogs': true, 'cell-icon-link': true }}),
              //   h('span', {
              //     domProps: {
              //       title: '配置设备'
              //     }
              //   }, '设备')
              // ]),

              h('Dropdown', {
                props: { trigger: 'hover', placement: 'bottom' },
                on: {
                  'on-click': (name) => {
                    if (params.row.id) {
                      this.onDropdownItemClick(name, params.row)
                    }
                  }
                }
              }, [
                h('DropdownItem', { style: { color: '#126D91' }}, [
                  h('i', { class: { 'fas': true, 'fa-layer-group': true, 'cell-icon-link': true }}),
                  '其他',
                  h('Icon', { props: { type: 'ios-arrow-down' }})
                ]),
                h('DropdownMenu', { slot: 'list' }, [
                  h('DropdownItem', {
                    props: { name: 'action_download_cfg' }
                  }, [
                    h('i', { class: { 'fas': true, 'fa-download': true, 'cell-icon-link': true }}),
                    h('span', {
                      domProps: {
                        title: '下载配置文件'
                      }
                    }, '下载')
                  ]),
                  h('DropdownItem', {
                    props: { name: 'action_edit', disabled: !_this.updatePermitted }
                  }, [
                    h('i', { class: { 'fas': true, 'fa-edit': true, 'cell-icon-link': true }}),
                    h('span', { domProps: { title: _this.updatePermitted ? '编辑车库终端' : '您没有权限编辑车库终端' }}, '编辑')
                  ]),
                  h('DropdownItem', {
                    props: { name: 'action_delete', disabled: !_this.deletePermitted }
                  }, [
                    h('i', { class: { 'fas': true, 'fa-trash': true, 'cell-icon-link': true }}),
                    h('span', { domProps: { title: _this.deletePermitted ? '删除车库终端' : '您没有权限删除车库终端' }}, '删除')
                  ])
                ])
              ])
              // h('a', {
              //   style: { color: '#126D91', marginRight: '10px' },
              //   domProps: {
              //     href: _this.$config.storageHost + '/config/' + params.row.address + '.ovpn',
              //     target: '_blank'
              //   }
              // }, [
              //   h('i', { class: { 'fas': true, 'fa-download': true, 'cell-icon-link': true }}),
              //   h('span', {
              //     domProps: {
              //       title: '下载配置文件'
              //     }
              //   }, '下载')
              // ]),
              // h('a', {
              //   style: getLinkTextStyle(_this.updatePermitted),
              //   on: {
              //     click: () => {
              //       if (params.row.id && _this.updatePermitted) {
              //         this.showFormModalDialog(params.row.id)
              //       }
              //     }
              //   }
              // }, [
              //   h('i', { class: { 'fas': true, 'fa-edit': true, 'cell-icon-link': true }}),
              //   h('span', { domProps: { title: _this.updatePermitted ? '编辑车库终端' : '您没有权限编辑车库终端' }}, '编辑')
              // ]),
              // h('a', {
              //   style: getLinkTextStyle(_this.deletePermitted),
              //   on: {
              //     click: () => {
              //       if (params.row.id && _this.deletePermitted) {
              //         this.showDelModalDialog(params.row.id, params.row.label)
              //       }
              //     }
              //   }
              // }, [
              //   h('i', { class: { 'fas': true, 'fa-trash': true, 'cell-icon-link': true }}),
              //   h('span', { domProps: { title: _this.deletePermitted ? '删除车库终端' : '您没有权限删除车库终端' }}, '删除')
              // ])
            ])
          }
        }
      ]
    }
  },
  watch: {
    showModal(val) {
    }
  },
  methods: {
    onDropdownItemClick(name, data) {
      if (name === 'action_download_cfg') {
        window.open(this.$config.storageHost + '/config/' + data.address + '.ovpn')
      } else if (name === 'action_edit') {
        this.showFormModalDialog(data.id)
      } else if (name === 'action_delete') {
        this.showDelModalDialog(data.id, data.label)
      }
    },
    onDeviceDropdownItemClick(name, data) {
      if (name === 'action_config_device') {
        this.showAgentDeviceModalDialog(data.id)
      } else if (name === 'action_provision_device') {
        this.provisionDevice(data.id, data.label)
      }
    },
    showFormModalDialog: function(id) {
      this.entityId = id ? parseInt(id) : 0
      this.modalForm = true
    },
    showAgentDeviceModalDialog: function(id) {
      this.entityId = id
      this.modalAgentDevice = true
      this.modalForm = false
    },
    provisionDevice: function(id, label) {
      this.$Modal.confirm({
        title: '确认下发终端设备么？',
        loading: true,
        render: (h, params) => {
          return h('ul', { style: { padding: '10px 25px 0', fontSize: '9pt' }}, [h('li', {}, label)])
        },
        onOk: function() {
          const _that = this
          request({
            url: this.$config.apiContextPath + '/sync/device',
            method: 'POST',
            data: [id]
          }).then(res => {
            this.$Notice.success({
              title: '下发成功',
              desc: '下发设备命令成功，后台将会开启异步同步!'
            })
            this.$Modal.remove()
          }).catch(() => {
            this.$Notice.error({
              title: '下发失败',
              desc: '下发设备命令失败，请稍微尝试!'
            })
            _that.buttonLoading = false
          })
        }
      })
    },
    showOpenDoorModalDialog: function(label, address, id) {
      const _this = this
      this.$Modal.confirm({
        title: '确认进行远程开闸么？',
        loading: true,
        render: (h, params) => {
          return h('ul', { style: { padding: '10px 25px 0' }}, [h('li', {}, label)])
        },
        onOk: function() {
          const _that = this
          request({
            url: this.$config.apiContextPath + '/sync/cmd',
            method: 'POST',
            data: {
              address: address,
              cmd: 'OPEN_GATE'
            }
          }).then(res => {
            this.$Notice.success({
              title: '开闸成功',
              desc: '车库终端 `' + label + '` 开闸成功!'
            })
            _this.modCount = _this.modCount + 1
            this.$Modal.remove()
          }).catch(error => {
            this.$Notice.error({
              title: '开闸失败',
              desc: '车库终端 `' + label + '` 开闸失败, 错误信息: ' + error
            })
            _that.buttonLoading = false
          })
        }
      })
    },
    showSyncModalDialog: function(id, label) {
      const _this = this
      this.$Modal.confirm({
        title: '确认同步终端数据么？',
        loading: true,
        render: (h, params) => {
          return h('ul', { style: { padding: '10px 25px 0', fontSize: '9pt' }}, [h('li', {}, label)])
        },
        onOk: function() {
          const _that = this
          request({
            url: this.$config.apiContextPath + '/sync/agent',
            method: 'POST',
            data: [id]
          }).then(res => {
            this.$Notice.success({
              title: '同步发送成功',
              desc: '车库终端 `' + label + '` 同步请求成功发送!'
            })
            _this.modCount = _this.modCount + 1
            this.$Modal.remove()
          }).catch(error => {
            this.$Notice.error({
              title: '数据同步失败',
              desc: '车库终端 `' + label + '` 同步失败, 错误信息: ' + error
            })
            _that.buttonLoading = false
          })
        }
      })
    },
    onAgentModalClose: function(changed = false) {
      this.modalForm = false
      this.modalAgentDevice = false
      if (changed) {
        this.modCount = this.modCount + 1
      }
    },
    showRebootModalDialog: function(label, address) {
      const _this = this
      this.$Modal.confirm({
        title: '确认重启车库终端么？',
        loading: true,
        render: (h, params) => {
          return h('ul', { style: { padding: '10px 25px 0' }}, [h('li', {}, label)])
        },
        onOk: function() {
          const _that = this
          request({
            url: this.$config.apiContextPath + '/sync/cmd',
            method: 'POST',
            data: {
              address: address,
              cmd: 'REBOOT'
            }
          }).then(res => {
            this.$Notice.success({
              title: '重启成功',
              desc: '车库终端 `' + label + '` 重启成功!'
            })
            _this.modCount = _this.modCount + 1
            this.$Modal.remove()
          }).catch(error => {
            this.$Notice.error({
              title: '重启失败',
              desc: '车库终端 `' + label + '` 重启失败, 错误信息: ' + error
            })
            _that.buttonLoading = false
          })
        }
      })
    },
    showDelModalDialog: function(id, label) {
      const _this = this
      this.$Modal.confirm({
        title: '确认删除车库终端么？',
        loading: true,
        render: (h, params) => {
          return h('ul', { style: { padding: '10px 25px 0' }}, [h('li', {}, label)])
        },
        onOk: function() {
          const _that = this
          request({
            url: _this.action + '/' + id,
            method: 'DELETE'
          }).then(res => {
            this.$Notice.success({
              title: '数据删除成功',
              desc: '车库终端 `' + label + '` 删除成功!'
            })
            _this.modCount = _this.modCount + 1
            this.$Modal.remove()
          }).catch(error => {
            this.$Notice.error({
              title: '数据删除失败',
              desc: '车库终端 `' + label + '` 删除失败, 错误信息: ' + error
            })
            _that.buttonLoading = false
          })
        }
      })
    },
    closeModal: function(changed = false) {
      this.url = ''
      this.entityId = 0
      this.$emit('on-close', changed)
    }
  }
}
</script>
